import { Tab } from '../../../../../modals/product/ProductModal';

export default {
  title: 'Nieuw product',
  tabs: {
    [Tab.General]: 'Algemeen',
    [Tab.NutritionInfo]: 'Voedingsinformatie',
  },
  form: {
    categories: {
      label: 'Categorieën',
    },
    printer: {
      label: 'Printer',
    },
    name: {
      label: 'Naam',
      placeholder: 'Cheeseburger',
    },
    description: {
      label: 'Beschrijving',
      placeholder: '180g runderburger, sla, tomaten, komkommers, jalapeños en yuppisaus',
    },
    external_id: {
      label: '{{integration}} ref',
      placeholder: 'bijv. HubRise SKU-referentie',
      read_only_hint:
        'Alleen bewerkbaar als een HubRise-integratie is verbonden en menusynchronisatie is uitgeschakeld.',
    },
    price: {
      label: 'Basisprijs',
    },
    has_smart_pricing: {
      label: 'Speciale prijzen voor afhalen en bezorging',
    },
    pickup_price: {
      label: 'Afhaalprijs',
      placeholder: 'Niet opgegeven',
    },
    delivery_price: {
      label: 'Bezorgprijs',
      placeholder: 'Niet opgegeven',
    },
    image: {
      label: 'Afbeelding (optioneel)',
    },
    has_combo_tax: {
      label: 'Heeft combobelasting',
    },
    is_available: {
      label: 'Op voorraad',
      subtitle: 'Zichtbaar op menu',
    },
    is_visible: {
      label: 'Zichtbaar',
      title: 'Zichtbaar op menu',
      subtitle_on: 'Klanten kunnen dit item zien',
      subtitle_off: 'Verborgen voor alle klanten',
    },
    is_available_for_pickup: {
      label: 'Beschikbaar voor afhalen',
      subtitle_on: 'Klanten kunnen bestellen voor afhalen',
      subtitle_off: 'Verborgen in afhaalmenu',
    },
    is_available_for_delivery: {
      label: 'Beschikbaar voor bezorging',
      subtitle_on: 'Klanten kunnen bestellen voor bezorging',
      subtitle_off: 'Verborgen in bezorgmenu',
    },
    modifiers: {
      label: 'Aanpassingen',
    },
  },
  labels: {
    smart_pricing_update_warning: 'Bij opslaan worden alle bestaande slimme prijsregels voor dit product overschreven.',
    smart_pricing_remove_warning: 'Na opslaan worden alle bestaande slimme prijsregels voor dit product verwijderd.',
  },
  availability: {
    title: 'Beschikbaarheid',
    helper:
      'Zichtbaarheid is de hoofdschakelaar. Schakel een kanaal uit om dit item te verbergen voor afhaal- of bezorgklanten zonder het van het menu te verwijderen.',
    status: {
      both: 'Beide kanalen',
      pickup_only: 'Alleen afhalen',
      delivery_only: 'Alleen bezorging',
      hidden: 'Verborgen',
      no_channels: 'Geen kanalen',
    },
    warning: {
      no_channels: 'Dit item is zichtbaar maar op geen enkel kanaal beschikbaar — klanten kunnen het niet bestellen.',
    },
    placeholder: '—',
    list_badge: {
      pickup_only: 'Alleen afhalen',
      delivery_only: 'Alleen bezorging',
      no_channels: 'Geen kanalen',
    },
  },
  buttons: {
    save: 'Opslaan',
    close: 'Sluiten',
  },
  toasts: {
    changes_got_saved: 'Wijzigingen zijn succesvol opgeslagen!',
  },
};
